import React from 'react';
import InsertTapCardImage from '../../../assets/images/terminal/insert-or-tap-card.png';

const InsertTapCard = ({ amount, onCardDetected, config }) => {
  return (
    <div className={`bg-white text-gray-800 h-full flex flex-col items-center justify-center p-4 ${config.ui.maxWidth} mx-auto`}>
      {/* Amount Display */}
      <div className="text-center mb-8">
        <div className="text-lg font-medium text-gray-700 mb-2">Total Amount</div>
        <div className="text-4xl font-bold text-gray-900">${amount || '0.00'}</div>
      </div>

      {/* Insert or Tap Card Image */}
      <div className="mb-8">
        <img 
          src={InsertTapCardImage} 
          alt="Tap or insert card" 
          className="w-60 h-60 object-contain"
        />
      </div>

      {/* Manual continue button for testing */}
      <button 
        onClick={onCardDetected}
        className="px-6 py-3 bg-green-600 text-white font-bold rounded-lg hover:bg-green-700 transition-colors"
      >
        CONTINUE
      </button>
    </div>
  );
};

export default InsertTapCard;